import React, {useEffect} from 'react';
import { useHistory } from 'react-router-dom'
import Main from './Main';

const NoMatch = () => {

  let history = useHistory()

  useEffect(()=>{ history.push('/') }, [])

  return (
    <Main>
      <div style={{textAlign:'center', paddingTop:'40px', paddingBottom:'50px'}}>
        <strong>pretii</strong>
      </div>
    </Main>
  );
};

export default NoMatch;
